import globalConstants from '../global/global-constants';
const brandConstants = {
    defaultSpacing: 10,
    colors: {
        ...globalConstants.colors,
        primary: '#0C121C',
        primary_light: '#82868B',
        primary_dark: '#0C121C',
        primary_text: '#262626',
        primary_disabled: '#E5E8E8',
        secondary: '#0C121C',
        secondary_dark: '#0C121C',
        secondary_light: '#4A4F54',
        light_grey: '#8D8D8D',
        dark_grey: '#656565',
        white: '#FFFFFF',
        bg_alternative: '#F8F9F9',
        bg_third: '#E9ECEC',
        third: '#4A4F54',
        third_hover: '#8298b3',
        bg_fourth: '#DEE2E2',
        bg_fifth: '#3C3C3B',
        bg_sixth: '#E1E1E1',
        slider: '#A5A7AA',
        text_header: '#444444',
        text_accent: '#8D8D8D',
        text_description: '#141414',
        error: '#D5302D',
        error_bold: '#FF0000',
        disabled: '#E5E8E8',
        fourth: '#FAFCFE',
        bg_disabled_input: '#73767B',
        forth_dark: '#777B7F',
        seventh: '#00b039',
        eighth: '#E9F7EA',
        bg_status_disabled: '#8E8E8E',
        bg_status_authorized: '#012059',
        bg_status_inProgress: '#1149AA',
        bg_approved: '#00D308',
        ninth: '#C8CACB',
        error_light: '#DC1226',
    },
    fontFamilies: {
        primary: [
            'Avenir',
            'Land Rover OT4',
            'LandRoverWeb',
            'Arial',
            'Helvetica',
            'sans-serif',
        ].join(','),
        primary_bold: ['LandRoverWebBold', 'Arial', 'Helvetica', 'sans-serif'].join(','),
        light: ['LandRoverWeb', 'Arial', 'Helvetica', 'sans-serif'].join(','),
        light_bold: [
            'Avenir',
            'LandRoverWeb',
            'Arial',
            'Helvetica',
            'sans-serif',
        ].join(','),
        heavy: [
            'Land Rover OT4',
            'Boris-Black-Bloxx',
            'Avenir-Black',
            'Arial-Bold',
            'sans-serif',
        ].join(','),
    },
    fontSizes: {
        xxs: 10,
        xs: 12,
        sm: 14,
        md: 16,
        lg: 20,
        xl: 24,
        xl_lg: 28,
        xxl: 38,
    },
    screens: {
        xs: 0,
        sm: 768,
        md: 960,
        lg: 1280,
        xl: 1920,
    },
};
export default brandConstants;
//# sourceMappingURL=brand-constants.js.map